<template>
  <div class="unlimited_services">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7 col-md-7">
          <div class="services_section_thumb">
            <img :src=" getBaseUrl + '' " height="320" alt="">
          </div>
        </div>
        <div class="col-lg-5 col-md-5">
          <div class="unlimited_services_content">
            <h1>Listas de favoritos</h1>
            <p>¿<b>Realizas compras regulares</b> y necesitas seleccionar cada vez todos los productos uno por uno? A partir de ahora te
      lo ponemos mucho más fácil con las <b>listas de productos favoritos</b>. Crea tu lista de favoritos y selecciona 
      cada producto especificando la cantidad. En la siguiente compra <b>con un solo click</b> podrás añadir todos
      los productos <b>al carrito de compra</b>.</p>
            <div class="view__work">
              <router-link :to=" { name: 'user-help', params: { language: getLocale } } ">Más información <i class="fa fa-angle-right"></i></router-link>
            </div>
          </div>
          <div @click="close" class="close-favlist"><i class="fa fa-close"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'

  export default {
    data() {
      return {
        visible: true,
      }
    },
    computed: {	
      ...mapGetters( ['getLocale', 'getBaseUrl'])
    },
    methods: {
      ...mapMutations(['mutateAdVisiblity']),
      close() {
        this.$store.commit('mutateAdVisiblity', false)
      },
    },   

  }

</script>
